
export default class SelectableObject<T>{
    Object: T;
    IsSelected: boolean;

    constructor(obj: T, isSelected: boolean) {
        this.Object = obj;
        this.IsSelected = isSelected;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/helpers/SelectableObject.ts